import React from 'react';
import { Link } from 'react-router5';
import {useTranslation} from "react-i18next";

const Tab = ({children, active = 0}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState(active);

  const tabsData = React.Children.map(children, (element) => {
    if(!React.isValidElement(element)) return;

    const {props: { tab, root, params, children, options}} = element;
    return {tab, root, params, children, options}
  }).filter(x => x);

  return (
    <ul className="c-tab-menu_list">
      {
        tabsData.map((c, i) => (

          <Link routeName={c.root}
                routeOptions={c.options || {}}
                routeParams={c.params}
                key={i}
                className={`c-tab-list_el ${i} ${i === activeTab ? "active" : ""}`}
                onClick={() => {setActiveTab(i)}}>
            {t(`${c.tab}`)}
          </Link>
        ))
      }
    </ul>
  )
}

const TabPane = ({children}) => {
  return {children}
}

Tab.TabPane = TabPane;

export default Tab
